export default __webpack_public_path__ + "static/media/downloadgooglepllay.d2c7e767.png";